import {LOCALE_ID, NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {AppRoutingModule} from "./app-routing.module";
import {AppComponent} from "./app.component";
import {CoreModule} from "./core/core.module";
import {UiModule} from "@fedeltapointofsale/ui";
import {MainModule} from "./main/main.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {APP_BASE_HREF} from "@angular/common";

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        BrowserModule,
        CoreModule,
        UiModule,
        AppRoutingModule,
        MainModule,
        FormsModule,
        ReactiveFormsModule
    ],
    providers: [
        {
            provide: APP_BASE_HREF,
            useValue: "/backoffice/"
        },
        {
            provide: LOCALE_ID,
            useValue: "en-US"
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
